import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Filter from "./Filter/Filter";
import LottiePlayer from "lottie-react";
import noDataFound from "../Assets/animationIcons/noDataFound.json";
import { CancelIcon, SearchesCIcon, CloseIcon } from "../Assets/iconshere";
import Skeleton from "react-loading-skeleton";
import apiClient from "../apiClient";

const GroupsTab = ({ search = "", setSearch = "", groupTypesList, onSelect }) => {
  var params = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  var { uuid } = params;
  const [groupsList, setGroupsList] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let formattedAllocationData = {
      name: "Group type",
      tags: groupTypesList.map((e) => ({ id: e.id, name: e.name })).sort((c, d) => c.name.localeCompare(d.name)),
    };
    setFilterOptions([formattedAllocationData]);
  }, [groupTypesList]);

  var fetchGroups = async () => {
    try {
      // var { data } = await axios.get(`${configData.config.UNO_URL}/api/user/group/list/${uuid}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });

      const data = await apiClient.get(`${configData.config.UNO_URL}/api/user/group/list/${uuid}`);

      setLoading(false);
      setGroupsList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, [uuid]);

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  const filterCourses = (e) => {
    if (search.length && !e.name.toLowerCase().includes(search.toLowerCase())) return false;
    if (selectedCheckboxes.length && !selectedCheckboxes.map((f) => f.id).includes(e.typeId)) return false;

    return true;
  };
  let filteredList = groupsList.filter(filterCourses);

  const loadBox = 4;
  const tileCards = [];

  for (let i = 0; i < loadBox; i++) {
    tileCards.push(
      <div key={`tile-${i}`} className="tilecard p-0 mb-3" style={{ outline: "none" }}>
        <div className="groupcardesign">
          <div className="avatarimg p-0" style={{ outlineColor: "#ffffff00" }}>
            <Skeleton count={1} circle height="100%" width="100%" className="m-0 p-0" />
          </div>
          <h6 className="groupname"> </h6>
          <div className="groupusercount d-flex flex-column gap-2">
            <p>
              <Skeleton width="10vw" className="my-1" />{" "}
            </p>
            <p>
              <Skeleton width="10vw" className="my-1" />{" "}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row pt-4 mt-3">
        <div className="col-md-12 d-flex align-items-center justify-content-end">
          <form className=" app-search app-search1 d-flex justify-content-start me-2">
            <div className="position-relative">
              <SearchesCIcon />
              {search.length > 0 && (
                <span className="searchiconcancel" onClick={() => setSearch("")}>
                  <CancelIcon />
                </span>
              )}
              <input
                type="text"
                name="searchName"
                className="form-control"
                placeholder="Search"
                autoComplete="off"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </form>

          <Filter
            selectedCheckboxes={selectedCheckboxes}
            setSelectedCheckboxes={setSelectedCheckboxes}
            filterOptions={filterOptions}
          />
        </div>
      </div>

      {selectedCheckboxes.length > 0 && (
        <div className="filerlist mt-3">
          <span>Filters:</span>
          {selectedCheckboxes.map((f, i) => {
            return (
              <span key={i + 1} className="filtertag">
                {f.name}
                <span onClick={() => handleCancelTag(f)}>
                  <CloseIcon />
                </span>
              </span>
            );
          })}
          <span className="filtertag clear" onClick={() => setSelectedCheckboxes([])} style={{ cursor: "pointer" }}>
            Clear all
          </span>
        </div>
      )}

      <div className="courses-parent usergrouplist">
        {loading ? (
          <div className="course-tiles mt-2">{tileCards}</div>
        ) : (
          <>
            {filteredList.length > 0 ? (
              <div className="course-tiles mt-2">
                {filteredList.map((group, index) => {
                  return (
                    <div className="tilecard p-0 mb-3" key={group.uuid}>
                      <div className="groupcardesign" onClick={() => onSelect(group)}>
                        {group.avatar ? (
                          <div className="avatarimg">
                            <img
                              src={group.avatar}
                              alt={`Avatar for ${group.name}`}
                              title={group.name}
                              referrerPolicy={"no-referrer"}
                            />
                          </div>
                        ) : (
                          <div className="initials-placeholder">
                            {group?.name
                              ?.split(" ")
                              .map((word) => word[0])
                              .slice(0, 2)
                              .join("")}
                          </div>
                        )}
                        <h6 className="groupname"> {group.name} </h6>
                        <div className="groupusercount">
                          <p>
                            {group.groups} Sub-Groups <span className="mx-1">|</span>
                          </p>
                          <p> {group.users} Users </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <>
                <div className="text-center mt-5 no-data-found">
                  <LottiePlayer animationData={noDataFound} style={{ height: 200 }} autoplay loop />
                  <h5>No Groups Found</h5>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default GroupsTab;
